import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Datenschutz = () => {
  const { language } = useLanguage();

  const renderGerman = () => (
    <CardContent className="prose dark:prose-invert max-w-none space-y-6 text-sm md:text-base leading-relaxed">
      <section>
        <p className="text-muted-foreground italic">
          Stand: Juni 2026
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">1. Datenschutz auf einen glance</h2>
        <h3 className="text-lg font-medium mb-1">Allgemeine Hinweise</h3>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
        </p>
        <h3 className="text-lg font-medium mb-1">Datenerfassung auf unserer Website</h3>
        <p>
          <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung sowie unserem Impressum entnehmen.
        </p>
        <p>
          <strong>Wie erfassen wir Ihre Daten?</strong><br />
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Registrierungsformular eingeben.<br />
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
        </p>
        <p>
          <strong>Wofür nutzen wir Ihre Daten?</strong><br />
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens oder zur Abwicklung der Funktionen unseres Services (z. B. Registrierung, Prognosemärkte, E-Mail-Verifizierung) verwendet werden.
        </p>
        <p>
          <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">2. Allgemeine Hinweise und Pflichtinformationen</h2>
        <h3 className="text-lg font-medium mb-1">SSL- bzw. TLS-Verschlüsselung</h3>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </p>
        <p>
          Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">3. Empfänger und Verantwortlicher</h2>
        <h3 className="text-lg font-medium mb-1">Hinweis zur verantwortlichen Stelle</h3>
        <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
        <p className="bg-secondary/30 p-4 rounded-lg">
          Ramon Cemil Kimyon<br />
          Theodor-Heuss-Straße 13<br />
          37075 Göttingen<br />
          E-Mail: rckimyon@icloud.com
        </p>
        <p>
          Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">4. Datenerfassung auf unserer Website</h2>
        <h3 className="text-lg font-medium mb-1">Hosting</h3>
        <p>
          Wir hosten die Inhalte unserer Website bei einem externen Dienstleister (Dienstleister für Webhosting). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den servern des Hosters gespeichert. Dies können v. a. IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Webseitenzugriffe und sonstige Daten, die über eine Website generiert werden, sein.
        </p>
        <p>
          Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
        </p>

        <h3 className="text-lg font-medium mb-1">Server-Log-Dateien</h3>
        <p>
          Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL (die zuvor besuchte Seite)</li>
          <li>Hostname des zugreifenden Rechners (IP-Adresse)</li>
          <li>Uhrzeit der Serveranfrage</li>
        </ul>
        <p>
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
        </p>
        <p>
          Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
        </p>

        <h3 className="text-lg font-medium mb-1">Cookies (Session-Management)</h3>
        <p>
          Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht.
        </p>
        <p>
          Wir verwenden technisch notwendige Cookies zur Gewährleistung der Benutzerauthentifizierung und des Login-Status (JWT-Tokens / Session-Management). Die Rechtsgrundlage für die Speicherung dieser technisch notwendigen Cookies ist Art. 6 Abs. 1 lit. f DSGVO bzw. § 25 Abs. 2 TDDDG, da das Speichern zwingend erforderlich ist, um den von Ihnen ausdrücklich gewünschten Dienst (Login-Bereich, Prognosen abgeben) bereitzustellen.
        </p>

        <h3 className="text-lg font-medium mb-1">Registrierung auf dieser Website</h3>
        <p>
          Sie können sich auf dieser Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. Die dazu eingegebenen Daten (Benutzername, E-Mail-Adresse, Passwort) verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, für den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben müssen vollständig angegeben werden. Andernfalls müssen wir die Registrierung ablehnen.
        </p>
        <p>
          Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt zum Zwecke der Durchführung des durch die Registrierung begründeten Nutzungsverhältnisses und ggf. zur Anbahnung weiterer Verträge (Art. 6 Abs. 1 lit. b DSGVO).
        </p>

        <h3 className="text-lg font-medium mb-1">E-Mail-Verarbeitung und PHPMailer</h3>
        <p>
          Wenn Sie sich auf unserer Website registrieren oder Passwort-Zurücksetzungs-E-Mails anfordern, versendet unser System automatisierte Transaktions-E-Mails unter Verwendung des E-Mail-Dienstprogramms PHPMailer und unseres SMTP-Versandservers. Hierbei wird Ihre E-Mail-Adresse verarbeitet, um den E-Mail-Versand zu ermöglichen.
        </p>
        <p>
          Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer verlässlichen und sicheren E-Mail-Zustellung).
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">5. Betroffenenrechte</h2>
        <p>Sie haben als betroffene Person folgende Rechte nach der DSGVO:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Recht auf Auskunft (Art. 15 DSGVO):</strong> Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.
          </li>
          <li>
            <strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht, unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen.
          </li>
          <li>
            <strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Sie haben das Recht, die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.
          </li>
          <li>
            <strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen, oder wir die Daten nicht mehr benötigen, Sie diese jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen.
          </li>
          <li>
            <strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.
          </li>
          <li>
            <strong>Widerruf Ihrer Einwilligung zur Datenverarbeitung (Art. 7 Abs. 3 DSGVO):</strong> Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </li>
          <li>
            <strong>Beschwerderecht bei der zuständigen Aufsichtsbehörde (Art. 77 DSGVO):</strong> Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres üblichen Aufenthaltsortes, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
          </li>
        </ul>

        <h3 className="text-lg font-medium mt-4 mb-1">Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</h3>
        <p>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BASIERT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG.
        </p>
        <p>
          WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN, ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
        </p>
      </section>
    </CardContent>
  );

  const renderEnglish = () => (
    <CardContent className="prose dark:prose-invert max-w-none space-y-6 text-sm md:text-base leading-relaxed">
      <section>
        <p className="text-muted-foreground italic">
          Last updated: June 2026
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">1. Data Protection at a Glance</h2>
        <h3 className="text-lg font-medium mb-1">General Information</h3>
        <p>
          The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data refers to any data that can be used to identify you personally. For detailed information on data protection, please refer to our Privacy Policy listed below.
        </p>
        <h3 className="text-lg font-medium mb-1">Data Collection on Our Website</h3>
        <p>
          <strong>Who is responsible for the data collection on this website?</strong><br />
          The data processing on this website is carried out by the website operator. Their contact details can be found in the section "Information on the Controller" of this Privacy Policy and in our Legal Imprint.
        </p>
        <p>
          <strong>How do we collect your data?</strong><br />
          On one hand, your data is collected when you provide it to us. This could, for example, be data you enter into a registration form.<br />
          Other data is collected automatically or with your consent when you visit the website through our IT systems. This is primarily technical data (e.g., internet browser, operating system, or time of page access). This data is collected automatically as soon as you enter our website.
        </p>
        <p>
          <strong>What do we use your data for?</strong><br />
          Part of the data is collected to ensure the error-free provision of the website. Other data may be used to analyze your user behavior or to handle the functions of our service (e.g., registration, prediction markets, email verification).
        </p>
        <p>
          <strong>What rights do you have regarding your data?</strong><br />
          You have the right at any time to receive information free of charge about the origin, recipient, and purpose of your stored personal data. You also have the right to request the rectification or erasure of this data. If you have given consent to data processing, you can revoke this consent at any time for the future. You also have the right to request the restriction of the processing of your personal data under certain circumstances. Furthermore, you have the right to lodge a complaint with the competent supervisory authority.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">2. General and Mandatory Information</h2>
        <h3 className="text-lg font-medium mb-1">SSL or TLS Encryption</h3>
        <p>
          For security reasons and to protect the transmission of confidential content, such as orders or inquiries you send to us as the site operator, this site uses SSL or TLS encryption. You can recognize an encrypted connection by the browser's address line changing from "http://" to "https://" and by the lock symbol in your browser line.
        </p>
        <p>
          If SSL or TLS encryption is activated, the data you transmit to us cannot be read by third parties.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">3. Data Controller</h2>
        <h3 className="text-lg font-medium mb-1">Information on the Controller</h3>
        <p>The controller responsible for data processing on this website is:</p>
        <p className="bg-secondary/30 p-4 rounded-lg">
          Ramon Cemil Kimyon<br />
          Theodor-Heuss-Straße 13<br />
          37075 Göttingen<br />
          Email: rckimyon@icloud.com
        </p>
        <p>
          The controller is the natural or legal person who alone or jointly with others decides on the purposes and means of the processing of personal data (e.g., names, email addresses, etc.).
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">4. Data Collection on Our Website</h2>
        <h3 className="text-lg font-medium mb-1">Hosting</h3>
        <p>
          We host our website's content with an external service provider (web hosting provider). The personal data collected on this website is stored on the host's servers. This can include IP addresses, contact requests, meta and communication data, website accesses, and other data generated via a website.
        </p>
        <p>
          The host is used for the purpose of fulfilling contracts with our potential and existing customers (Art. 6 para. 1 lit. b GDPR) and in the interest of a secure, fast, and efficient provision of our online offer by a professional provider (Art. 6 para. 1 lit. f GDPR).
        </p>

        <h3 className="text-lg font-medium mb-1">Server Log Files</h3>
        <p>
          The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Browser type and browser version</li>
          <li>Operating system used</li>
          <li>Referrer URL (the previously visited page)</li>
          <li>Host name of the accessing computer (IP address)</li>
          <li>Time of the server request</li>
        </ul>
        <p>
          This data will not be merged with other data sources.
        </p>
        <p>
          This data is collected on the basis of Art. 6 para. 1 lit. f GDPR. The website operator has a legitimate interest in the technically error-free presentation and optimization of their website – the server log files must be recorded for this purpose.
        </p>

        <h3 className="text-lg font-medium mb-1">Cookies (Session Management)</h3>
        <p>
          Our web pages use so-called "cookies". Cookies are small data packages and do not cause any damage to your end device. They are stored on your device either temporarily for the duration of a session (session cookies) or permanently (permanent cookies). Session cookies are automatically deleted at the end of your visit.
        </p>
        <p>
          We use technically necessary cookies to ensure user authentication and login status (JWT tokens / session management). The legal basis for storing these technically necessary cookies is Art. 6 para. 1 lit. f GDPR or § 25 para. 2 TDDDG, as storage is absolutely necessary to provide the service explicitly requested by you (login area, placing predictions).
        </p>

        <h3 className="text-lg font-medium mb-1">Registration on this Website</h3>
        <p>
          You can register on this website to use additional features. We use the data entered for this purpose (username, email address, password) only for the purpose of using the respective offer or service for which you have registered. The mandatory information requested during registration must be provided in full. Otherwise, we must refuse the registration.
        </p>
        <p>
          The processing of the data entered during registration is carried out for the purpose of implementing the user relationship established by registration and, if necessary, for initiating further contracts (Art. 6 para. 1 lit. b GDPR).
        </p>

        <h3 className="text-lg font-medium mb-1">Email Processing and PHPMailer</h3>
        <p>
          When you register on our website or request password reset emails, our system sends automated transactional emails using the PHPMailer utility and our SMTP dispatch server. Your email address is processed to enable email delivery.
        </p>
        <p>
          Data processing is carried out on the basis of Art. 6 para. 1 lit. b GDPR (contract performance or pre-contractual measures) and Art. 6 para. 1 lit. f GDPR (legitimate interest in reliable and secure email delivery).
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">5. Data Subject Rights</h2>
        <p>As a data subject, you have the following rights under the GDPR:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Right of Access (Art. 15 GDPR):</strong> You have the right to request information about your personal data processed by us.
          </li>
          <li>
            <strong>Right to Rectification (Art. 16 GDPR):</strong> You have the right to demand the immediate correction of incorrect or completion of your personal data stored by us.
          </li>
          <li>
            <strong>Right to Erasure (Art. 17 GDPR):</strong> You have the right to request the erasure of your personal data stored by us, unless processing is necessary for exercising the right of freedom of expression and information, for compliance with a legal obligation, for reasons of public interest, or for the establishment, exercise, or defense of legal claims.
          </li>
          <li>
            <strong>Right to Restriction of Processing (Art. 18 GDPR):</strong> You have the right to request the restriction of processing of your personal data if you contest the accuracy of the data, the processing is unlawful but you oppose its erasure, or we no longer need the data but you require it for the establishment, exercise, or defense of legal claims.
          </li>
          <li>
            <strong>Right to Data Portability (Art. 20 GDPR):</strong> You have the right to receive the personal data you provided to us in a structured, commonly used, and machine-readable format or to request its transmission to another controller.
          </li>
          <li>
            <strong>Right to Withdraw Consent (Art. 7 para. 3 GDPR):</strong> Many data processing operations are only possible with your express consent. You can withdraw consent you have already given at any time. The legality of the data processing carried out until the withdrawal remains unaffected.
          </li>
          <li>
            <strong>Right to Lodge a Complaint with a Supervisory Authority (Art. 77 GDPR):</strong> In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority, in particular in the Member State of their habitual residence, place of work, or place of the alleged violation.
          </li>
        </ul>

        <h3 className="text-lg font-medium mt-4 mb-1">Right to Object to Data Collection in Special Cases and to Direct Marketing (Art. 21 GDPR)</h3>
        <p>
          IF DATA PROCESSING IS BASED ON ART. 6 PARA. 1 LIT. E OR F GDPR, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA AT ANY TIME FOR REASONS ARISING FROM YOUR PARTICULAR SITUATION; THIS ALSO APPLIES TO PROFILING BASED ON THESE PROVISIONS. THE RESPECTIVE LEGAL BASIS ON WHICH PROCESSING IS BASED CAN BE FOUND IN THIS PRIVACY POLICY.
        </p>
        <p>
          IF YOU OBJECT, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL DATA UNLESS WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE YOUR INTERESTS, RIGHTS, AND FREEDOMS, OR THE PROCESSING SERVES THE ESTABLISHMENT, EXERCISE, OR DEFENSE OF LEGAL CLAIMS (OBJECTION UNDER ART. 21 PARA. 1 GDPR).
        </p>
      </section>
    </CardContent>
  );

  return (
    <div className="bg-background pb-20">
      <main className="container mx-auto px-4 pt-24 max-w-3xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold">
              {language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'}
            </CardTitle>
          </CardHeader>
          {language === 'de' ? renderGerman() : renderEnglish()}
        </Card>
      </main>
    </div>
  );
};

export default Datenschutz;
